module.exports = __webpack_public_path__ + "img/arrows-right.59a84123.svg";